module.exports = __webpack_public_path__ + "img/footer-contact-instagram.4919eda7.svg";